import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export default function CtaSection({ onScheduleDemo }: { onScheduleDemo: () => void }) {
  return (
    <section className="py-20">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl font-bold mb-4">Ready to scale?</h2>
        <p className="text-lg text-muted-foreground max-w-xl mx-auto mb-8">
          Join the sales teams that stopped duct-taping tools together and
          started growing with AMPA Network.
        </p>
        <Button
          size="lg"
          className="text-base px-10 bg-[#3b82f6] hover:bg-[#3b82f6]/90"
          onClick={onScheduleDemo}
        >
          Schedule a Demo
          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </section>
  );
}
